import { observer } from 'mobx-react-lite';
import { cn } from '@/utils/utils';
import { useStore } from '@/hooks/useStore';
import { Button } from '@/components/common/Button';
import { Link, useLocation } from 'react-router-dom';
import { ekDomain } from '@/configs/constants';
import Menu from './_components/Menu';
import { isPathEk } from '@/utils/routes';
import SmallSystemLogo from '@/assets/images/logo/small-system-logo.png';
import { URL_CONFIG } from '@/configs/environment';
import { LogoCMS } from '@/components/general/logo/Logo';

export default observer(function SideBar() {
    // hooks
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    // store
    const {
        uiStore: { isOpenSidebar }
    } = useStore();

    return (
        <aside
            className={cn(
                'fixed top-0 left-0 z-20 h-screen -translate-x-full lg:translate-x-0 transition-[width] ease-in-out duration-300 backdrop-blur bg-black-5',
                isOpenSidebar === false ? 'w-[90px]' : 'w-72'
            )}
        >
            <div className='relative h-full flex flex-col px-0 pb-3 pt-0 shadow-md'>
                {/* Brand top */}
                <Button
                    className='transition-transform ease-in-out duration-300 px-0 h-16 w-full rounded-none'
                    variant='link'
                    asChild
                >
                    {isOpenSidebar ?
                        (
                            <div className='flex items-center px-5 py-2 m-0 w-full shadow'>
                                <LogoCMS linkClassName='h-12 w-auto' />
                            </div>
                        ) :
                        (
                            <Link
                                to={`${isEk ? `${URL_CONFIG.APP.url}/${ekDomain}` : `${URL_CONFIG.DOMAIN_WORDPRESS.url}`}`}
                                className={cn(
                                    'flex items-center px-5 py-2 m-0 w-full shadow',
                                    isOpenSidebar ? '!justify-start' : ''
                                )}
                            >
                                <div className='h-full flex justify-center items-center w-auto transition-all ease-in-out duration-300'>
                                    <img src={SmallSystemLogo} alt='Logo' className='h-12 transition-all ease-in-out duration-300' />
                                </div>
                            </Link>
                        )}
                </Button>

                {/* Menu */}
                <Menu isOpen={isOpenSidebar} />
            </div>
        </aside>
    );
});
